<template>
  <div class="stepContent">

    <div class="download">
      <div style="width: 80%;">
        <el-form :model="batchInfo" ref="batchInfo" :rules="batchInfoRules" label-width="100px">
          <el-row :gutter="21" style="margin-left: -30px">
            <!--<el-col :span="7">
              <el-form-item label="客户名称" prop="cusId">
                <el-select v-model="batchInfo.cusId" :placeholder="$t('logon.selectCustomer')">
                  <el-option v-for="item in customInfoList"
                             :key="item.id"
                             :label="item.cusName"
                             :value="item.id">
                  </el-option>
                </el-select>
                &lt;!&ndash; <el-input v-model="batchInfo.clientName"></el-input> &ndash;&gt;
              </el-form-item>
            </el-col>-->
            <el-col :span="7">
              <el-form-item label="薪资模板" prop="salaryTemplateId">
                <el-select v-model="batchInfo.salaryTemplateId" placeholder="请选择模板">
                  <el-option v-for="item in templateInfoList"
                             :key="item.id"
                             :label="item.templateName"
                             :value="item.id">
                  </el-option>
                </el-select>

                <!-- <el-input v-model="batchInfo.salaryTemplate"></el-input> -->
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <p @click="downloadFiles">
        <svg class="icon" aria-hidden="true" >
          <use xlink:href="#icon-xiazai"></use>
        </svg>
        下载导入模板
      </p>
      <p @click="dialogVisible = true">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-xiazai"></use>
        </svg>
        自定义下载模板
      </p>
    </div>
    <div class="uploadBox">
      <el-upload
        v-loading="loading"
        :show-file-list="false"
        :on-success="fileUploadSuccess"
        :on-error="fileUploadError"
        :before-upload="beforeFileUpload"
        action="/api/file"
        class="uploadContent"
        drag
        accept=".xls,.xlsx">
        <i class="el-icon-upload"/>
        <div class="el-upload__text">点击或将文件拖到此处上传</div>
      </el-upload>
    </div>
    <div class="uploadTip">
      <div class="uploadTip-title">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-tishi"></use>
        </svg>
        温馨提示
      </div>
      <div class="uploadTip-lists">
        <div class="uploadTip-list">
          1、支持文件后缀 xls、xlsx文件，且不超过10M
        </div>
        <div class="uploadTip-list">
          2、请将要上传的内容放在第一个sheet中
        </div>
        <div class="uploadTip-list">
          3、第一个sheet中首行必须为表头，且不支持复合表头
        </div>
        <div class="uploadTip-list">
          4、请不要加密模板文件，将导致错误
        </div>
      </div>
    </div>
    <div v-if="next" class="next-btn">
      <el-button type="primary" @click="goback" size="mini">返回</el-button>
      <el-button type="primary" @click="nextStep" size="mini">下一步</el-button>
    </div>
    <el-dialog
      v-dialog-drag
      ref=""
      width="70%"
      title="自定义表头"
      :visible.sync="dialogVisible"
    >
      <tree-transfer :title="title" :from_data='fromData' :to_data='toData' :defaultProps="{label:'label'}"
                     @addBtn='add' @removeBtn='remove' :mode='mode' height='540px' filter openAll>
      </tree-transfer>
      <div
        class="marginTop30"
        style="text-align: center"
      >
        <el-button
          type="primary"
          @click=""
        >
          确认
        </el-button>
        <el-button @click="dialogVisible = false">
          取消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  /* eslint-disable handle-callback-err */
  import treeTransfer from "el-tree-transfer"; // 引入
  import {downLoadFile} from "@/api/user/user";
  import {uploadStepOne} from "@/api/wage/batchTemplate";
  import bspFileUpload from "@/components/bsp/bsp-file-upload/bsp-file-upload";
  import {getCurrentCustomerInfos,getArllTemplateInfos} from "@/api/wage/batchTemplate";
  import {downloadFile} from "@/util/util";
  import {downloadEmpExcelTmpl} from "@/api/common/common";
  export default {
    // eslint-disable-next-line vue/no-unused-components
    components: { treeTransfer,bspFileUpload,uploadStepOne,getCurrentCustomerInfos,getArllTemplateInfos}, // 注册
    props:{
      fileId:{
        type:String,
        default:''
      },
      fileName:{
        type:String,
        default:''
      },
    },
    created(){
      // this.getCustomerInfoList();
      this.getTemplateInfoList();
    },
    data() {
      return {
        dialogVisible: false,
        customInfoList:[], //客户信息列表
        templateInfoList: [], //模板信息列表
        batchInfo:{
          fileId:'',
          fileName:''
        }, //批次信息
        batchInfoRules:{  //表单校验规则
          cusId: [],
          salaryTemplateId: [],
          balance: [],
          salaryDate: [],
          taxDate: []
        },
        headerInfo: {}, // 接受后台返回的表头信息
        uploadUrl: '',//导入地址
        loading: false,
        next: false,//默认下一步不显示
        mode: "transfer", // transfer addressList
        tmplInfo:{
          tmplId:'BATCHPAY_INFO',
          fileName:'薪资模板.xls'
        },
        fromData: [
          {
            id: "1",
            pid: 0,
            label: "一级 1",
            children: [
              {
                id: "1-1",
                pid: "1",
                label: "二级 1-1",
                children: []
              },
              {
                id: "1-2",
                pid: "1",
                label: "二级 1-2",
                children: [
                  {
                    id: "1-2-1",
                    pid: "1-2",
                    children: [],
                    label: "二级 1-2-1"
                  },
                  {
                    id: "1-2-2",
                    pid: "1-2",
                    children: [],
                    label: "二级 1-2-2"
                  }
                ]
              }
            ]
          }
        ],
        toData: [
          {
            id: "zxc",
            pid: '0',
            label: "加一级 1",
            disabled:true,
            children: [
              {
                id: "asd",
                pid: "zxc",
                label: "加二级 1-1",
                children: [],
                disabled:true
              },
              {
                id: "qqq",
                pid: "zxc",
                label: "加二级 2-2",
              disabled:true,
                children: [
                  {
                    id: "2-2-1",
                    pid: "qqq",
                    children: [],
                    label: "加二级 2-2-1",
                    disabled:true
                  },
                  {
                    id: "2-2-2",
                    pid: "qqq",
                    children: [],
                    label: "加二级 2-2-2",
                    disabled:true
                  }
                ]
              }
            ]
          }]
      };
    },
    methods: {
      getTemplateInfoList: function(){
        getArllTemplateInfos().then(res=>{
          let rs=res.data
          if(rs.code==0){
            this.templateInfoList=rs.data
          }else{
            this.$message.error('获取模板信息列表失败')
          }
        })
      },
      // 获取客户信息列表
      getCustomerInfoList: function(){
        getCurrentCustomerInfos().then(res=>{
          let rs=res.data
          if(rs.code==0){
            this.customInfoList=rs.data
            console.log(this.customInfoList)
          }else{
            this.$message.error('客户信息获取失败')
          }
        })
      },
      removeFile: function(){

      },
      //downloadfile
      downloadFiles(){
        console.log("点击下载模板："+this.tmplInfo.tmplId+"文件名称："+this.tmplInfo.fileName);
        downloadEmpExcelTmpl(this.tmplInfo).then(res => {
          downloadFile(res);
        })
      },
      beforeFileUpload(file) {
        this.$set(this, "loading", true);
        let isExcel = true;
        const isxls = file.type === "application/vnd.ms-excel";
        const isxlsx = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const isLtM = file.size / 1024 / 1024 < 10;

        if (!isxls && !isxlsx) {
          isExcel = false;
          this.$message.error("导入文件只能是 xls,xlsx 格式!");
          this.$set(this, "loading", false);
        }
        if (!isLtM) {
          this.$message.error("导入文件大小不能超过 10MB!");
          this.$set(this, "loading", false);
        }
        return isExcel && isLtM;
      },
      fileUploadSuccess(res, file, fileList) {
        this.$set(this, "loading", false);
        this.fileId='';
        if (res) {
          if (file.status != "success" ) {
            this.$message.error( res.msg );
          } else {
            // 赋值数据  用于下一个页面使用
            /*this.$store.state.impData.contentList = res.data.contentList;
            this.$store.state.impData.noMatchTitleList = res.data.noMatchTitleList;
            this.$store.state.impData.matchTitleList = res.data.matchTitleList;
            this.$store.state.impData.fileTitleList = res.data.fileTitleList;
            this.next = true;*/
            for (let i = 0,l=fileList.length; i <l; i++) {
              if(i<(l-1)){
                this.fileId +=fileList[i].response.fileId+",";
                this.fileName +=fileList[i].response.fileName+",";
              }else {
                // this.fileId +=fileList[i].response.fileId;
                // this.fileName +=fileList[i].response.fileName;
                this.batchInfo.fileId=fileList[i].response.fileId;
                this.batchInfo.fileName=fileList[i].response.fileName;
              }
            }

            if (res.fileId) {
              console.log(res.fileId)
              this.$emit('update:fileId', this.fileId)
              this.$emit('update:fileName', this.fileName)
              this.$message.success('上传成功');
              this.nextStep();//出发下一步
            } else{
              this.$message.error(res.msg);
            }

          }
        }
      },
      fileUploadError(err, file, fileList) {
        this.$set(this, "loading", false);
        this.$message.error( "导入失败!" );
      },
      nextStep() {
        debugger

        console.log(this.batchInfo)
        uploadStepOne(this.batchInfo).then(res=>{
          debugger
          let rs=res.data
          this.headerInfo=rs.data
          let param={
            headerInfo: this.headerInfo,
            batchInfo: this.batchInfo
          }
          this.$emit("onupload",param); // 跳转下一步
        })
        this.next = true;
      },
      // goback() {
      //   this.$emit("goTopage"); // 返回
      //
      // },
      goback() {
        const query = {}
        console.log("编辑参数query=",query);
        // 返回数据页面
        this.$router.push({ path: '/wage/data-ready-template', query});
      },
// 监听穿梭框组件添加
      add(fromData, toData, obj) {
// 树形穿梭框模式transfer时，返回参数为左侧树移动后数据、右侧树移动后数据、移动的        {keys,nodes,halfKeys,halfNodes}对象
// 通讯录模式addressList时，返回参数为右侧收件人列表、右侧抄送人列表、右侧密送人列表
        console.log("fromData:", fromData);
        console.log("toData:", toData);
        console.log("obj:", obj);
      },
// 监听穿梭框组件移除
      remove(fromData, toData, obj) {
// 树形穿梭框模式transfer时，返回参数为左侧树移动后数据、右侧树移动后数据、移动的{keys,nodes,halfKeys,halfNodes}对象
// 通讯录模式addressList时，返回参数为右侧收件人列表、右侧抄送人列表、右侧密送人列表
        console.log("fromData:", fromData);
        console.log("toData:", toData);
        console.log("obj:", obj);
      }
    }
  }
</script>
<style scoped rel="stylesheet/scss">
  .stepContent {
    width: 92%;
    margin: 20px auto 0;
    box-shadow: 0px 0px 10px #dedede;
    padding: 30px;
    border-radius: 5px;
  }

  .download {
    display: flex;
    justify-content: flex-end;
  }

  .download p {
    margin-left: 20px;
    line-height: 50px;
    color: #269cff;
    cursor: pointer;
  }

  .download p svg {
    margin-right: 10px;
  }

  .download p:hover {
    text-decoration: underline;
  }

  .uploadBox {
    border-radius: 5px;
    margin-bottom: 20px;
  }

  .uploadContent {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
  }

  .uploadContent .iconfont {
    font-size: 80px;
    color: #cccccc;
  }

  .uploadContent {
    height: 300px;
  }

  .uploadBox >>> .el-upload {
    width: 100%;
    height: 100%;
  }

  .uploadBox >>> .el-upload-dragger {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .uploadBox >>> .el-upload-dragger .el-icon-upload {
    margin-top: 0;
  }

  .uploadText {
    color: #aaaaaa;
  }

  .uploadTip {
    background-color: #eeeeee;
    padding: 20px;
    color: #666666;
    font-size: 12px;
  }

  .uploadTip-title {
    font-size: 16px;
    color: #333333;
    line-height: 30px;
  }

  .uploadTip-lists {
    padding-left: 20px;
  }

  .uploadTip-list {
    line-height: 30px;
  }

  .uploadTip-list .uploadTip-button {
    color: #269cff;
    text-decoration: underline;
    cursor: pointer;
  }

  .next-btn {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
</style>
